export default {
  name: "Legal Entity Name",
  entity: "Legal Entity",
  iik: "IIK",
  inn: "Tax ID",
  bin: "BIN",
  bic: "BIC",
  bankBic: "Bank BIC",
  bankMFO: "MFI Bank",
  codeFiscal: "Fiscal Code",
  head_name_description:
    "Enter the full name of the responsible person for automatic generation of acts and invoices",
  mainOrganization: "Main Legal Entity",
  mainOrganizationHint:
    "The main legal entity is used for tariff purchases and remains active when deactivated. The main legal entity can be changed no more than once every 14 days",
  chooseMainOrganization: "Select Legal Entity",
  maxOrganizationError: "Maximum number of organizations created",
  moderOrganizationError:
    "You cannot add a new organization while moderation is in progress",
  aboutTitle: "Information about your organization",
  typeOrganization: "Organization Type",
  bankName: "Bank Name",
  legalAddress: "Legal Address",
  currentAccountNumber: "Checking Account Number",
  correspondentAccount: "Correspondent Account",
  vatCode: "VAT Code",
  addressFieldRequired: "Legal entity address not entered",
  metaIsRequired: "Bank details not entered",
  add: {
    button: "Create Organization",
  },
  registrationNumber: "Registration number",
  // popup Aliexpress
  entities: "Legal Entities",
  head_name: "Head's Full Name",
  ogrn: "PSRN",
  ogrnOgrnip: "PSRN / PSRNSP",
  legalTypes: "Legal Form",
  taxSystem: "Taxation Type",
  monthlyTurnover: "Monthly Turnover Amount",
  depositSum: "Deposit Amount",
  okvedLabel: "Main Activity Type",
  legalEntityCharter: "Legal Entity Charter",
  mainEntity: "Main",
  mainEntityInfo: [
    "The main legal entity is used for purchasing tariffs and remains active if a new tariff is not paid after its expiration.",
    "The main legal entity can be changed no more than once every 14 days.",
  ],
  cantCreateModal: {
    title: "You've created the maximum number of legal entities on your tariff",
  },
  deposit: "Deposit",
  enterInnOrEntityName: "Enter Tax ID or legal entity name",
  entityCreating: "Creating Legal Entity",
  updateEntityNotifyMessage: {
    create: "Legal entity submitted for moderation",
    edit: "Legal entity data successfully changed",
  },
  commercial: "Commercial Legal Entity",
  uncommercial: "Non-commercial Legal Entity",
  depositMinSumHint:
    "Minimum account balance. Amount not less than {minDeposit} RC that remains in the balance when withdrawing funds.",
  entityType: "Legal Entity Type",
  entityInfo: "Legal Entity Information",
  bankDetails: "Bank Details",
  frequencyMainEntityChanging:
    "The main legal entity can be changed no more than once every 14 days.",
  abailableChangeMainEntity:
    "Changing the main legal entity will be available from {nextChangeDate}.",
  mainEntityDescription:
    "Will be used for purchasing tariffs and remains active if a new tariff is not paid after its expiration.",
  entityHasHalal: "Legal entity has Halal certificate",
  headNameToSendActs:
    "Full name of the responsible person for automatic generation of acts and invoices",
  certHalal: "Halal Certificate",
  makeMainEntity: "Make {entityName} the main legal entity?",
  successChangedMainEntity: "Main legal entity successfully changed",
  mainEntityUseForBuyingTariff:
    "The main legal entity is used for purchasing tariffs and remains active if a new tariff is not paid after its expiration.",
  afterConfirmYouCanChangeMainEntityIn14Days:
    "After clicking 'Confirm', you will be able to change the main legal entity again no earlier than 14 days later.",
  cancelCreationModal: {
    title: "Cancel legal entity creation?",
    subtitle:
      "Entered data will not be saved. To continue creating the legal entity, click 'Back'.",
  },
  pressBackToSave:
    "Click the 'Back' button to save changes or continue editing.",
  congratulateWithCreateEntity:
    "Congratulations on creating your legal entity!",
  entityInModerationNow:
    "Your legal entity is currently under review. This takes from 24 to 48 hours.",
  toPassModerationPayBill:
    "To pass verification, you need to pay an invoice from the specified legal entity by downloading it using the button below. You can also find the invoice in your account: in the 'My Businesses' section - 'Documents' under the name 'Test Payment'.",
};
